import { Helmet } from 'react-helmet-async';
import React from 'react';
import requireAuth from '../../../../lib/requireAuth.jsx';
import withRouterParams from '../../../../lib/withRouterParams.jsx';

import StepStakeholderFormContainer from '../../../../containers/projects/StakeholderFormContainers/StepStakeholderFormContainer.jsx';

const EditProfileStepStakeholder = ({ projectId, stakeholderId, slug }) => (
  <>
    <Helmet>
      <title>Edit Stakeholder | ChangeSync</title>
    </Helmet>
    <StepStakeholderFormContainer
      projectId={projectId}
      stakeholderId={stakeholderId}
      slug={slug}
    />
  </>
);

EditProfileStepStakeholder.getInitialProps = ({ query }) => ({
  projectId: Number(query.projectId),
  stakeholderId: Number(query.stakeholderId),
  slug: query.slug,
});

export default requireAuth(withRouterParams(EditProfileStepStakeholder));
